import {Component, OnDestroy, OnInit} from '@angular/core';
import {AccountService, AlertService, GroupService, UserService} from "../services";
import { Subject } from 'rxjs';
import {User} from "../models";
import {ActivatedRoute} from "@angular/router";
import {first} from "rxjs/operators";
import {ServiceService} from "../services/service.service";
import {Service} from "../models/service";
import {ComponentTitleService} from "../services/componentTitle.service";

import { locale as polish } from './i18n/pl';
import { locale as english } from './i18n/en';
import {FuseTranslationLoaderService} from "../../../@fuse/services/translation-loader.service";

@Component({
    templateUrl: './serviceDetails.component.html',
    styleUrls: ['./serviceDetails.component.scss']
})
export class ServiceDetailsComponent implements OnDestroy, OnInit {
    id: string;
    service: Service;

    constructor(
        private userService: UserService,
        private alertService: AlertService,
        private accountService: AccountService,
        private route: ActivatedRoute,
        private serviceService: ServiceService,
        private componentTitleService: ComponentTitleService,
        private translationLoader: FuseTranslationLoaderService
    ) {
        componentTitleService.clearTitle();
        componentTitleService.addPart('Services');

        this.translationLoader.loadTranslations(polish, english);
    }

    ngOnInit() {
        this.id = this.route.snapshot.params['id'];

        this.serviceService.getById(this.id)
            .pipe(first())
            .subscribe(x => {
                this.service = x;

                this.componentTitleService.addPart(x.name);
            });
    }

    ngOnDestroy(): void {

    }
}
